import { Box, EnergyGrade } from 'enova-frontend-components';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import styled from '../../../styled';
import BarA from '../../../assets/energimerke/energiskala/barA.svg?react';
import BarB from '../../../assets/energimerke/energiskala/barB.svg?react';
import BarC from '../../../assets/energimerke/energiskala/barC.svg?react';
import BarD from '../../../assets/energimerke/energiskala/barD.svg?react';
import BarE from '../../../assets/energimerke/energiskala/barE.svg?react';
import BarF from '../../../assets/energimerke/energiskala/barF.svg?react';
import BarG from '../../../assets/energimerke/energiskala/barG.svg?react';
import KarakterA from '../../../assets/energimerke/energiskala/karakterA.svg?react';
import KarakterB from '../../../assets/energimerke/energiskala/karakterB.svg?react';
import KarakterC from '../../../assets/energimerke/energiskala/karakterC.svg?react';
import KarakterD from '../../../assets/energimerke/energiskala/karakterD.svg?react';
import KarakterE from '../../../assets/energimerke/energiskala/karakterE.svg?react';
import KarakterF from '../../../assets/energimerke/energiskala/karakterF.svg?react';
import KarakterG from '../../../assets/energimerke/energiskala/karakterG.svg?react';
import { EnergimerkeV2025 as EnergimerkeV2025Type } from '../../../types/energimerke';

import { BarWrapper, EnergimerkeWrapper, KarakterWrapper } from './styledComponents';

const StyledBox = styled(Box)`
  width: 100%;
  max-width: 600px;
`;

interface Props {
  energimerke: EnergimerkeV2025Type;
}

export const EnergimerkeV2025: FC<Props> = ({ energimerke }) => {
  const { t } = useTranslation();

  const ariaLabel = t('energimerke.ariaDescription', {
    energikarakter: energimerke?.energikarakter
  });

  return (
    <StyledBox>
      <EnergimerkeWrapper aria-label={ariaLabel}>
        <BarWrapper gridRow={1}>
          <BarA />
        </BarWrapper>
        <BarWrapper gridRow={2}>
          <BarB />
        </BarWrapper>
        <BarWrapper gridRow={3}>
          <BarC />
        </BarWrapper>
        <BarWrapper gridRow={4}>
          <BarD />
        </BarWrapper>
        <BarWrapper gridRow={5}>
          <BarE />
        </BarWrapper>
        <BarWrapper gridRow={6}>
          <BarF />
        </BarWrapper>
        <BarWrapper gridRow={7}>
          <BarG />
        </BarWrapper>

        {energimerke?.energikarakter === EnergyGrade.A && (
          <KarakterWrapper gridRow={1}>
            <KarakterA />
          </KarakterWrapper>
        )}
        {energimerke?.energikarakter === EnergyGrade.B && (
          <KarakterWrapper gridRow={2}>
            <KarakterB />
          </KarakterWrapper>
        )}
        {energimerke?.energikarakter === EnergyGrade.C && (
          <KarakterWrapper gridRow={3}>
            <KarakterC />
          </KarakterWrapper>
        )}
        {energimerke?.energikarakter === EnergyGrade.D && (
          <KarakterWrapper gridRow={4}>
            <KarakterD />
          </KarakterWrapper>
        )}
        {energimerke?.energikarakter === EnergyGrade.E && (
          <KarakterWrapper gridRow={5}>
            <KarakterE />
          </KarakterWrapper>
        )}
        {energimerke?.energikarakter === EnergyGrade.F && (
          <KarakterWrapper gridRow={6}>
            <KarakterF />
          </KarakterWrapper>
        )}
        {energimerke?.energikarakter === EnergyGrade.G && (
          <KarakterWrapper gridRow={7}>
            <KarakterG />
          </KarakterWrapper>
        )}
      </EnergimerkeWrapper>
    </StyledBox>
  );
};
